import { memo } from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { SettingsCard } from './SettingsCard';
import { DisclaimerText } from '../MHM/MHMTypography';
import { Stack } from '@mui/material';
import { MHMButton } from '../MHM/MHMButton';
/* eslint-disable no-useless-escape */

export const BatteryLifeSettingsComponent = memo(
  function BatteryLifeSettingsComponent() {
    const { t } = useTranslation();

    return (
      <SettingsCard
        id="battery_life"
        title={t('Battery Life')}
        sx={{ overflow: 'unset' }}
      >
        <Stack gap={2} p={2}>
          <DisclaimerText>
            {t(
              'To view predicted battery life for given normal operating frequencies for devices with 100% charge, please use our battery life calculator tool available via the button below',
            )}
          </DisclaimerText>

          <MHMButton
            href="/battery_life"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ width: 'fit-content' }}
          >
            {t('Battery Life Calculator')}
          </MHMButton>
        </Stack>
      </SettingsCard>
    );
  },
);
